import { ServiceMappers, ServiceType } from '@/scopes/checkout/domain/types'
import {
  createBookingRedeemServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/bookingRedeemServiceMapper'
import { createBridgeServiceMapper } from '@/scopes/checkout/infrastructure/api/service-mappers/bridgeServiceMapper'
import { createBusServiceMapper } from '@/scopes/checkout/infrastructure/api/service-mappers/busServiceMapper'
import {
  createCancellationInsuranceServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/cancellationInsuranceServiceMapper'
import {
  createCarRentalFilteringServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/carRentalFilteringServiceMapper'
import {
  createClothingServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/clothingServiceMapper'
import {
  createDinnerVouchersServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/dinnerVouchersServiceMapper'
import {
  createGolfServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/golfServiceMapper'
import { createLuggageServiceMapper } from '@/scopes/checkout/infrastructure/api/service-mappers/luggageServiceMapper'
import {
  createPerBookingServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/perBookingServiceMapper'
import {
  createPerParticipantServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/perParticipantServiceMapper'
import { createPerRoomServiceMapper } from '@/scopes/checkout/infrastructure/api/service-mappers/perRoomServiceMapper'
import {
  createSkiAncillaryServiceMapper,
} from '@/scopes/checkout/infrastructure/api/service-mappers/skiAncillaryServiceMapper'

export const serviceMappers: ServiceMappers = {
  [ServiceType.CarRentalFiltering]: createCarRentalFilteringServiceMapper({
    serviceName: 'AUTOHUUR*',
    serviceTypeMapper: 'carRentalFilters',
    serviceType: ServiceType.CarRentalFiltering,
  }),
  [ServiceType.TravelInsurance]: createPerParticipantServiceMapper({
    serviceName: 'TRAVEL*',
    serviceTypeMapper: 'genericService',
    serviceType: ServiceType.TravelInsurance,
  }),
  [ServiceType.TravelInsurancePerBooking]: createPerBookingServiceMapper({
    serviceName: 'TRAVEL*',
    serviceTypeMapper: 'genericService',
    serviceType: ServiceType.TravelInsurancePerBooking,
  }),
  [ServiceType.CancellationInsurance]: createCancellationInsuranceServiceMapper({
    serviceName: 'CANCEL*',
    serviceTypeMapper: 'genericService',
    serviceType: ServiceType.CancellationInsurance,
  }),
  [ServiceType.CancellationInsurancePerBooking]: createPerBookingServiceMapper({
    serviceName: 'CANCEL*',
    serviceTypeMapper: 'genericService',
    serviceType: ServiceType.CancellationInsurancePerBooking,
  }),
  [ServiceType.MealplanDP]: createPerRoomServiceMapper({
    serviceName: 'ACCOMMODATION',
    serviceTypeMapper: 'mealplan',
    serviceType: ServiceType.MealplanDP,
  }),
  [ServiceType.BookingRedeem]: createBookingRedeemServiceMapper({
    serviceName: 'REDEEM',
    serviceTypeMapper: 'redeem',
    serviceType: ServiceType.BookingRedeem,
  }),
  [ServiceType.Luggage]: createLuggageServiceMapper({ serviceName: 'LUG_*', serviceTypeMapper: 'luggage', serviceType: ServiceType.Luggage }),
  [ServiceType.SkiPass]: createSkiAncillaryServiceMapper({
    serviceName: 'SKI*',
    serviceType: ServiceType.SkiPass,
    serviceTypeMapper: 'pass',
  }),
  [ServiceType.SkiMaterial]: createSkiAncillaryServiceMapper({
    serviceName: 'SKI*',
    serviceType: ServiceType.SkiMaterial,
    serviceTypeMapper: 'material',
  }),
  [ServiceType.SkiLesson]: createSkiAncillaryServiceMapper({
    serviceName: 'SKI*',
    serviceType: ServiceType.SkiLesson,
    serviceTypeMapper: 'lesson',
  }),
  [ServiceType.Sweater]: createClothingServiceMapper({
    serviceName: 'SWEATER*',
    serviceType: ServiceType.Sweater,
    serviceTypeMapper: 'genericService',
  }),
  [ServiceType.TShirt]: createClothingServiceMapper({
    serviceName: 'TSHIRT*',
    serviceType: ServiceType.TShirt,
    serviceTypeMapper: 'genericService',
  }),
  [ServiceType.Bus]: createBusServiceMapper({
    serviceName: 'BUS',
    serviceTypeMapper: 'bus',
    serviceType: ServiceType.Bus,
  }),
  [ServiceType.Golf]: createGolfServiceMapper({
    serviceName: 'GREENFEE',
    serviceTypeMapper: 'golf',
    serviceType: ServiceType.Golf,
  }),
  [ServiceType.Bridge]: createBridgeServiceMapper({
    serviceName: 'BRIDGE',
    serviceTypeMapper: 'bridge',
    serviceType: ServiceType.Bridge,
  }),
  [ServiceType.DinnerVouchers]: createDinnerVouchersServiceMapper({
    serviceName: 'MEAL-VOUCHERS',
    serviceType: ServiceType.DinnerVouchers,
    serviceTypeMapper: 'dinnerVouchers',
  }),
  [ServiceType.GenericServicePerBooking]: createPerBookingServiceMapper({
    serviceName: 'GENERIC',
    serviceTypeMapper: 'genericService',
    serviceType: ServiceType.GenericServicePerBooking,
  }),
  [ServiceType.GenericServicePerParticipant]: createPerParticipantServiceMapper({
    serviceName: 'GENERIC',
    serviceType: ServiceType.GenericServicePerParticipant,
    serviceTypeMapper: 'genericService',
  }),
  [ServiceType.GenericServicePerRoom]: createPerRoomServiceMapper({
    serviceName: 'GENERIC',
    serviceType: ServiceType.GenericServicePerRoom,
    serviceTypeMapper: 'genericService',
  }),
}
